import { takeLatest } from 'redux-saga/effects';
import { BUY_SUBSCRIPTION_SUCCESS, PUBLISH_OFFER } from '../../reducers';
import { publishOffer } from './publishOffer';
import { afterSubscriptionBuy } from './afterSubscriptionBuy';

export function* publishInfoSagas() {
  yield takeLatest(PUBLISH_OFFER, publishOffer);
  yield takeLatest(BUY_SUBSCRIPTION_SUCCESS, afterSubscriptionBuy);
}
